import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NormalButton from 'components/atoms/Button/NormalButton';
import { useRequestDM } from 'modules/hooks';
import { removeTag, TagHighLight } from 'lib';
import { MESSAGE_TYPE } from 'helper';
import { autoCompleteReset } from 'modules/actions/autoComplete';
import PropTypes from 'prop-types';
const AutoComplete = ({ clearInputTextRef }) => {
  const sentenceList = useSelector(state => state.autoComplete.sentenceList);
  const autoActive = useSelector(state => state.autoComplete.active);
  const autoDisplay = useSelector(state => state.autoComplete.display);

  const dispatch = useDispatch();
  const onSendMessage = (text, type) => {
    dispatch(useRequestDM(text, type));
    dispatch(autoCompleteReset());
    clearInputTextRef();
  };
  return (
    { sentenceList } && (
      <div className="auto_complete_div">
        {sentenceList.map(sentence => (
          <NormalButton
            label={TagHighLight(sentence)}
            styleDef={{
              height: '40px',
              color: '#55555',
              borderColor: '#f44336',
              backgroundColor: '#fff',
              fontSize:'14px',
              fontWeight:'700'
            }}
            clickEvt={() => onSendMessage(removeTag(sentence), MESSAGE_TYPE.query)}
            key = {sentence+"_auto"}
          />
        ))}
      </div>
    )
  );
};
AutoComplete.propTypes = {
  clearInputTextRef: PropTypes.func,
};
AutoComplete.defaultProps = {
  clearInputTextRef: () => {},
};
export default AutoComplete;
